export default {
      id: "info-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.7315c2cd.svg#info",
      toString: function () {
        return this.url;
      }
    }